// extracted by mini-css-extract-plugin
export default {"container":"NavigationButtons_container__9tKhk","navButtonLeft":"NavigationButtons_navButtonLeft__-YZKZ","navButtonRight":"NavigationButtons_navButtonRight__r829O"};